module.exports = __webpack_public_path__ + "static/media/02_crear_combo_frase_final.e88db988.png";